import PropTypes from 'prop-types';
import { Tooltip, InputLabel, MenuItem, FormControl, Select, Grid, TextField } from '@mui/material';
import { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AddCustomLabelsForm from './AddCustomLabelsForm';
import StepDetailsTabContent from './stepDetailsForm/stepDetailsTabs/StepDetailsTabContent';
import AddHeadersForm from './AddHeadersForm';

const AlertConditionsForm = ({
  step,
  handleAlertCondition,
  webhookError,
  alertCondition,
  setAlertCondition,
  alertWebhook,
  alertWebhookAuthType,
  legacyNoAuthWebhookAvailable,
  customLabels,
  headers,
  setHeaders,
  setCustomLabels,
  environment
}) => {
  const [value, setValue] = useState(0);

  const handleChange = (e, newValue) => {
    e.preventDefault();
    setValue(newValue);
  };
  const min = 1;
  const max = 5;
  const [openCustomLabelsModal, setOpenCustomLabelsModal] = useState(false);
  const [openHeaderModal, setOpenHeaderModal] = useState(false);
  const [edit, setEdit] = useState(false);
  const getAllowedThreshold = (value) => {
    let allowedValue = parseInt(value, 10);
    if (allowedValue > max) allowedValue = max;
    if (allowedValue < min) allowedValue = min;
    return allowedValue;
  };

  return (
    <Grid hidden={step != 5} sx={{ my: '2rem', width: '100%' }}>
      <Grid sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="create step tabs">
          <Tab label="Define" />
          <Tab label="Webhook Headers" />
          <Tab label="Custom Labels" />
        </Tabs>
      </Grid>
      <StepDetailsTabContent value={value} index={0}>
        <Grid>
          <FormControl sx={{ minWidth: 300, mr: '1rem', mb: '1rem' }}>
            <InputLabel>Type</InputLabel>
            <Select
              sx={{ background: 'white', fontSize: environment && 14 }}
              label="Type"
              defaultValue={alertCondition ? alertCondition.type : ''}
              name="type"
              data-testid="alert-type"
              onChange={(e) => handleAlertCondition(e.target.value, 'type')}>
              <MenuItem value={''}>None</MenuItem>
              <MenuItem value={'consecutive failures'}>Consecutive Failures</MenuItem>
            </Select>
          </FormControl>
          <Tooltip title="Maximum allowed threshold is 5!">
            <TextField
              sx={{
                my: '0',
                mx: '1rem',
                width: 150,
                background: 'white'
              }}
              inputProps={{ min, max, style: { fontSize: environment && 14 } }}
              type="number"
              variant="outlined"
              value={alertCondition ? alertCondition.threshold : ''}
              label="Threshold"
              id="threshold"
              data-testid="alert-threshold"
              onChange={(e) =>
                handleAlertCondition(getAllowedThreshold(e.target.value), 'threshold')
              }
            />
          </Tooltip>
        </Grid>
        <FormControl sx={{ my: '1.2rem', minWidth: 480 }}>
          <InputLabel>Webhook Auth Type</InputLabel>
          <Select
            sx={{ background: 'white', fontSize: environment && 14 }}
            label="Webhook Auth Type"
            defaultValue={alertWebhookAuthType || ''}
            value={alertWebhookAuthType}
            name="type"
            data-testid="alert-auth-type"
            onChange={(e) => handleAlertCondition(e.target.value, 'authType')}>
            <MenuItem value={'STATIC_TOKEN'}>Static Token</MenuItem>
            {legacyNoAuthWebhookAvailable && <MenuItem value={'NO_AUTH'}>No Auth</MenuItem>}
          </Select>
        </FormControl>
        <Grid sx={{ mt: '1.2rem' }}>
          <TextField
            sx={{ width: 480, background: 'white' }}
            inputProps={{ style: { fontSize: environment && 14 } }}
            variant="outlined"
            value={alertWebhook ? alertWebhook : ''}
            label="Webhook"
            id="alert-webhook"
            data-testid="alert-webhook"
            onChange={(e) => handleAlertCondition(e.target.value, 'webhook')}
            error={!!webhookError}
            helperText={webhookError}
          />
        </Grid>
      </StepDetailsTabContent>
      <StepDetailsTabContent value={value} index={1}>
        <AddHeadersForm
          setOpenHeaderModal={setOpenHeaderModal}
          openHeaderModal={openHeaderModal}
          headers={headers}
          setHeaders={setHeaders}
          edit={edit}
          setEdit={setEdit}
          alertCondition={alertCondition}
          alertWebhook={alertWebhook}
          alertWebhookAuthType={alertWebhookAuthType}
          setAlertCondition={setAlertCondition}
          environment={environment}
        />
      </StepDetailsTabContent>
      <StepDetailsTabContent value={value} index={2}>
        <AddCustomLabelsForm
          setOpenCustomLabelsModal={setOpenCustomLabelsModal}
          openCustomLabelsModal={openCustomLabelsModal}
          customLabels={customLabels}
          setCustomLabels={setCustomLabels}
          edit={edit}
          setEdit={setEdit}
          alertCondition={alertCondition}
          alertWebhook={alertWebhook}
          setAlertCondition={setAlertCondition}
          environment={environment}
        />
      </StepDetailsTabContent>
    </Grid>
  );
};

AlertConditionsForm.propTypes = {
  alertWebhookAuthType: PropTypes.string.isRequired,
  legacyNoAuthWebhookAvailable: PropTypes.bool.isRequired,
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  setHeaders: PropTypes.func.isRequired
};

export default AlertConditionsForm;
